import React from 'react';
import _ from 'lodash';
import Warning from '../../common/Warning';

interface SelfProps {
    initialOpen?: boolean,
    forceOpen?: boolean,
    onOpen?: any,
    onClose?: any,
    warnings?: any,
    label: string,
    children: any,
    arrowFirst?: boolean,
    additionalClasses?: string[]
    alwaysOpen?: boolean
}

interface SelfState {
    open: boolean,
    duringOpen: boolean,
    duringClose: boolean
}

export default class ExpandableContainer extends React.Component<SelfProps, SelfState> {
    static EnterAnimationTime = 175
    static ExitAnimationTime = 100

    closeAnimationTimeout: number = 0;
    openAnimationTimeout: number = 0;

    state = {
        open: this.props.initialOpen ?? this.props.alwaysOpen ?? false,
        duringOpen: false,
        duringClose: false
    }

    UNSAFE_componentWillReceiveProps(nextProps: SelfProps) {
        if (nextProps.forceOpen && !this.props.forceOpen) {
            this.open()
        } else if (!nextProps.forceOpen && this.props.forceOpen) {
            if (this.state.duringOpen) {
                clearTimeout(this.openAnimationTimeout)
            }

            this.setState({
                open: false,
                duringOpen: false,
                duringClose: false
            })
        }
    }

    open() {
        if (this.closeAnimationTimeout) {
            clearTimeout(this.closeAnimationTimeout)
            this.closeAnimationTimeout = 0
        }

        this.setState({
            duringOpen: true,
            duringClose: false
        })

        this.openAnimationTimeout = setTimeout(() => {
            this.openAnimationTimeout = 0
            this.setState({
                duringOpen: false,
                duringClose: false,
                open: true
            })

            if (this.props.onOpen) {
                this.props.onOpen()
            }
        }, ExpandableContainer.EnterAnimationTime)
    }

    close() {
        if (this.openAnimationTimeout) {
            clearTimeout(this.openAnimationTimeout)
            this.openAnimationTimeout = 0
        }

        this.setState({
            duringOpen: false,
            duringClose: true
        })

        this.closeAnimationTimeout = setTimeout(() => {
            this.closeAnimationTimeout = 0
            this.setState({
                duringOpen: false,
                duringClose: false,
                open: false
            })

            if (this.props.onClose) {
                this.props.onClose()
            }
        }, ExpandableContainer.ExitAnimationTime)
    }

    onExpanderClick = () => {
        if (this.props.alwaysOpen) {
            return;
        }
        if (this.state.open) {
            this.close()
        } else {
            this.open()
        }
    }

    render() {
        let rootClassNames = ['expandable-container']
        if (this.props.additionalClasses) {
            rootClassNames.push(...this.props.additionalClasses)
        }

        if (this.state.duringOpen) {
            rootClassNames.push('expandable-container--enter-anim')
            rootClassNames.push('expandable-container--open')
        }

        if (this.state.duringClose) {
            rootClassNames.push('expandable-container--exit-anim')
            rootClassNames.push('expandable-container--open')
        }

        if (this.state.open) {
            rootClassNames.push('expandable-container--open')
        }

        const warnings = _.uniqBy((this.props.warnings || []).filter((x: any) => x), 'type');

        return (
            <div className={rootClassNames.join(' ')}>
                <div className="expandable-container-expander" onClick={this.onExpanderClick}>
                    {this.renderExpandableHeader()}
                    {warnings.map((x: any, idx) => <img key={idx} className="warning" src={Warning.GetIcon(x.color)}/>)}
                </div>
                <div className="expandable-container-body">
                    {this.props.children}
                </div>
            </div>
        )
    }

    renderExpandableHeader = () => {
        if (this.props.alwaysOpen) {
            return (<React.Fragment>
                <span className="label">{this.props.label}</span>
            </React.Fragment>);
        }
        if (this.props.arrowFirst) {
            return (<React.Fragment>
                <span className="icon first"></span>
                <span className="label">{this.props.label}</span>
            </React.Fragment>);
        }
        return (<React.Fragment>
            <span className="label">{this.props.label}</span>
            <span className="icon"></span>
        </React.Fragment>);
    }
}